import React, {useContext} from 'react';

const MenuContext = React.createContext();

export const useMenuContext = () => useContext(MenuContext);

export default MenuContext;
